import React, { useState } from 'react';
import { NavLink } from "react-router-dom";
import './Minimal.component.css';
import Logo from '../../assets/images/CPC Index Logo-01_white.png'

const Minimal = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);

    // Close menu when a NavLink is clicked on mobile
    const handleNavLinkClick = () => {
        setIsOpen(false);
    };

    return (
        <div>
            <nav className="navbar">
                <div className="menu-icon" onClick={() => setIsOpen(!isOpen)}>
                    ☰
                </div>
                <div className="logo">
                    <img src={Logo} alt="Logo" />
                </div>

                <ul className={`nav-links ${isOpen ? "open" : ""}`}>
                    <li>
                        <NavLink
                            to="/global_cpc"
                            activeClassName="active"
                            className="nav-link"
                            onClick={handleNavLinkClick}
                        >
                            Global CPC Index
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/national_cpc"
                            activeClassName="active"
                            className="nav-link"
                            onClick={handleNavLinkClick}
                        >
                            National CPC Index
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/methodology"
                            activeClassName="active"
                            className="nav-link"
                            onClick={handleNavLinkClick}
                        >
                            Methodology
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/cop_platform"
                            activeClassName="active"
                            className="nav-link"
                            onClick={handleNavLinkClick}
                        >
                            Child Protection in Cyberspace
                        </NavLink>
                    </li>
                </ul>
            </nav>
            <main>{children}</main>
        </div>
    );
};

export default Minimal;
